import type { DateLib } from '@shared/lib';

export { datePickerLocales } from './locales';

export const DEPARTURE_FIELD = 'dep' as const;
export const ARRIVAL_FIELD = 'arr' as const;

export type DateField = typeof DEPARTURE_FIELD | typeof ARRIVAL_FIELD;

export type SelectedDates = {
  from: DateLib.DateProp;
  to: DateLib.DateProp;
};

export const analyticsEvents = {
  CALENDAR_SUCCESS: 'calendar_success',
  CALENDAR_ERROR: 'calendar_error',
  NIGHTS_SUCCESS: 'nights_success',
  NIGHTS_ERROR: 'nights_error',
};
